import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectDefault from '../common/form/selectDefault';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './entregaActions';
import Th from '../common/table/th';
import THead from '../common/table/tHead';
import Table from '../common/table/table';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Tr from '../common/table/tr';
import TBody from '../common/table/tBody';
import FormatUtils from '../common/formatUtils/FormatUtils';
import materiaPrima from '../materiaPrima/materiaPrima';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class EntregaForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {
		
		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>						
						<Row>
							{!!this.props.formularioValues.id &&
							<Select
								name='id_solicitacao'
								options={this.props.listaSolicitacao}
								label='Solicitação *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={this.props.formularioValues.id ? 'readOnly' : readOnly}
								value={this.props.formularioValues.id_solicitacao}
								onChange={value => {
									const solicitacao = this.props.listaSolicitacao.filter(item => item.id == value)[0];

									this.props.initForm({
										...this.props.formularioValues,
										id_solicitacao: solicitacao ? solicitacao.id : null,
										nome_racao: solicitacao ? solicitacao.nome_racao : null,
										nome_parceiro: solicitacao ? solicitacao.nome_parceiro : null,
										quantidade: FormatUtils.formatarValorTela(solicitacao ? solicitacao.quantidade : 0, 2),
										id_unidade_medida: solicitacao ? solicitacao.id_unidade_medida : null
									});
									
								}} />}

							<Field
								name='nome_racao'
								component={LabelAndInput}
								label='Ração *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={'readOnly'} />

							<Field
								name='nome_parceiro'
								component={LabelAndInput}
								label='Parceiro *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={'readOnly'} />

							<Field
								name='quantidade'
								component={LabelAndInputNumber}
								label='Quantidade *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={180}
								readOnly={'readOnly'}
								title='Quantidade utilizada na fórmula'
								casas={2} />
							
							<Field
								name='id_unidade_medida'
								options={this.props.listaUnidadeMedida}
								component={Select}
								label='Unidade de Medida *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={300}
								readOnly={'readOnly'} />
						</Row>
						<Row>
							<Field
								name='id_veiculo'
								options={this.props.listaVeiculo}
								component={Select}
								label='Veículo *' placeholder='Informe'
								cols='12 4 3 3'
								readOnly={readOnly} />

							<Field
								name='id_motorista'
								options={this.props.listaMotorista}
								component={Select}
								label='Motorista *' placeholder='Informe'
								cols='12 8 9 9'
								readOnly={readOnly} />

							<LabelAndInputDate
								label='Agendamento'
								cols='12 1 1 1'
								readOnly={this.props.formularioValues.datahora_inicio ? 'readOnly' : readOnly}
								value={this.props.formularioValues.data_agendamento}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										data_agendamento: value
									});
								}} />

							<LabelAndInputDateTime
								label='Início da Entrega'
								cols='12 1 1 1'
								readOnly={readOnly}
								value={this.props.formularioValues.datahora_inicio}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										datahora_inicio: value
									});
								}} />

							<LabelAndInputDateTime
								label='Fim da Entrega'
								cols='12 1 1 1'
								readOnly={readOnly}
								value={this.props.formularioValues.datahora_fim}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										datahora_fim: value
									});
								}} />
						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }

}

EntregaForm = reduxForm({form: 'entregaForm', destroyOnUnmount: false})(EntregaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('entregaForm')(state),
	registro: state.entrega.registro,
	listaVeiculo: state.veiculo.listaSelect,
	listaMotorista: state.motorista.listaSelect,
	listaUnidadeMedida: state.unidadeMedida.listaSelect,
	listaSolicitacao: state.entrega.listaSolicitacao.map(item => ({
		...item,
		valor: `${item.id} - ${item.nome_parceiro} - ${item.nome_racao} - ${FormatUtils.formatarValorTela(item.quantidade, 2)} ${item.sigla_unidade_medida}`
	}))
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EntregaForm);
